import { movies, type Movie } from '@/mocks/movies';

export const getMovieById = (id: string): Movie | undefined => movies.find((m) => m.id === id);

export const getFeaturedMovies = (): Movie[] => movies.filter((m) => m.isFeatured);

export const getHotMovies = (): Movie[] => movies.filter((m) => m.isHot);

export const getRelatedMovies = (movie: Movie, limit = 6): Movie[] => {
  const sameGenre = movies.filter(
    (m) => m.id !== movie.id && m.genres.some((g) => movie.genres.includes(g)),
  );
  const sameType = movies.filter(
    (m) => m.id !== movie.id && m.type === movie.type && !sameGenre.includes(m),
  );
  return [...sameGenre, ...sameType].slice(0, limit);
};

export const sortMovies = (list: Movie[], key: string): Movie[] => {
  const copy = [...list];
  if (key === 'rating') return copy.sort((a, b) => b.rating - a.rating);
  if (key === 'hot') return copy.sort((a, b) => Number(b.isHot) - Number(a.isHot) || b.rating - a.rating);
  return copy.sort((a, b) => (a.updateTime < b.updateTime ? 1 : -1));
};

export const filterMovies = (
  list: Movie[],
  opts: { genre?: string; region?: string; year?: string },
): Movie[] => {
  return list.filter((m) => {
    if (opts.genre && opts.genre !== '全部' && !m.genres.includes(opts.genre)) return false;
    if (opts.region && opts.region !== '全部' && m.region !== opts.region) return false;
    if (opts.year && opts.year !== '全部') {
      if (opts.year === '更早') {
        if (m.year >= 2023) return false;
      } else if (String(m.year) !== opts.year) {
        return false;
      }
    }
    return true;
  });
};

export const formatMovieMeta = (movie: Movie): string => {
  if (movie.type === 'tv') {
    return `${movie.year} · ${movie.region} · ${movie.updatedTo ?? `全${movie.episodes}集`}`;
  }
  return `${movie.year} · ${movie.region} · ${movie.duration ?? '电影'}`;
};